import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "applicant-info" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "modals" }
const _hoisted_4 = { class: "request-funds" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 7,
  class: "error"
}

import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";
import Tile from "@/components/shared/Tile.vue";
import SchoolConfirmation from "@/components/loan-configuration/SchoolConfirmation.vue";
import BorrowAmount from "@/components/loan-configuration/BorrowAmount.vue";
import LoanOptions from "@/components/loan-configuration/LoanOptions.vue";
import TimeoutModal from "@/components/modals/TimeoutModal.vue";
import RequestFundsModalOpal from "@/components/modals/RequestFundsModalOpal.vue";
import NextButton from "@/components/shared/NextButton.vue";
import Error from "@/components/shared/Error.vue";
import OpalModal from "@/components/shared/OpalModal.vue";
import ConfirmYourLoanDetailsModal from "@/components/pel-loan-configuration/ConfirmYourLoanDetailsModal.vue";
import LocLoanConfigurationModal from "@/components/loan-configuration/LocLoanConfigurationModal.vue";
import PelLoanOptionsModal from "@/components/pel-loan-configuration/PelLoanOptionsModal.vue";
import PgLoanOptionsModal from "@/components/professional-grad/PgLoanOptionsModal.vue";
import CurrentRequestForFunds from "@/components/application-info/LOC/CurrentRequestForFunds.vue";
import useApplicationInfo from "@/composables/application-info/useApplicationInfo";
import Loader from "@/components/shared/Loader.vue";
import StudentInformation from "@/components/application-info/parent-loc/student/StudentInformation.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'ApplicationInfoLOC',
  props: {
    application: {},
    applicant: {}
  },
  setup(__props: any) {

const LocLoanConfigurationModalRef = ref<InstanceType<typeof LocLoanConfigurationModal>>();



const store = useStore();

const loanConfigurationModule = computed(() => store.state.loanConfigurationModule);
const applicationInfoModule = computed(() => store.state.applicationInfoModule);

const {
  confirmYourLoanDetailsModalActive,
  closeBorrowAmountModal,
  closeLoanConfigModal,
  closeLoanOptionsModal,
  closeSchoolConfirmationModal,
  complete,
  dataRetrievalError,
  error,
  fundsRequestBtnText,
  getApplicationDetails,
  gettingData,
  getLoanDetails,
  handleBorrowAmount,
  handleLoanConfigurationComplete,
  hasRepaymentBasedRates,
  initialDrawRequest,
  isParentLOC,
  isValidProfessionalGradFlow,
  loan,
  loanSvcError,
  openBorrowAmountModal,
  openBorrowAmountFromConfirm,
  openLoanOptionsModal,
  openSchoolConfirmationModal,
  openSchoolConfirmationFromConfirm,
  openLoanOptionsFromConfirm,
  openLoanConfigurationFromConfirm,
  showBorrowAmountModal,
  showFundsRequestModal,
  showLoanConfigurationModal,
  showLoanOptionsModal,
  showRequestFundsButton,
  showSchoolConfirmationModal,
  student,
  updatingApp,
  showPendingDisbursementNotice
} = useApplicationInfo();

async function handleUpdateBorrowAmount(event: {
  amount: number;
  requestedAmountChanged: boolean;
}) {
  const response = await handleBorrowAmount(event);

  if (LocLoanConfigurationModalRef.value) {
    LocLoanConfigurationModalRef.value.updatingBorrowAmount = !response;
  }
}

onMounted(async () => {
  await getApplicationDetails();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Tile, null, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "header" }, [
            _createElementVNode("p", { class: "title" }, "Your Current Request for Funds")
          ], -1)),
          _createElementVNode("div", _hoisted_1, [
            (_unref(gettingData))
              ? (_openBlock(), _createBlock(Loader, { key: 0 }))
              : _createCommentVNode("", true),
            ((_unref(loanSvcError) || _unref(dataRetrievalError)) && !_unref(gettingData))
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(Error)
                ]))
              : _createCommentVNode("", true),
            (!_unref(dataRetrievalError))
              ? (_openBlock(), _createBlock(CurrentRequestForFunds, {
                  key: 2,
                  loading: _unref(gettingData) || _unref(updatingApp),
                  onOpenSchoolConfirmationModal: _unref(openSchoolConfirmationModal),
                  onOpenBorrowAmountModal: _unref(openBorrowAmountModal),
                  onOpenLoanOptionsModal: _unref(openLoanOptionsModal)
                }, null, 8, ["loading", "onOpenSchoolConfirmationModal", "onOpenBorrowAmountModal", "onOpenLoanOptionsModal"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_3, [
              (_unref(showLoanConfigurationModal))
                ? (_openBlock(), _createBlock(LocLoanConfigurationModal, {
                    key: 0,
                    ref_key: "LocLoanConfigurationModalRef",
                    ref: LocLoanConfigurationModalRef,
                    application: __props.application,
                    applicant: __props.applicant,
                    term: __props.application?.schoolConfiguration?.academicTerm || '',
                    initialDrawRequest: loanConfigurationModule.value?.applicationInfo?.initialDraw,
                    onClose: _unref(closeLoanConfigModal),
                    onComplete: _unref(handleLoanConfigurationComplete),
                    onUpdateBorrowAmount: handleUpdateBorrowAmount
                  }, null, 8, ["application", "applicant", "term", "initialDrawRequest", "onClose", "onComplete"]))
                : _createCommentVNode("", true),
              (_unref(confirmYourLoanDetailsModalActive))
                ? (_openBlock(), _createBlock(ConfirmYourLoanDetailsModal, {
                    key: 1,
                    onOpenSchoolConfirmationModal: _unref(openSchoolConfirmationFromConfirm),
                    onOpenBorrowAmountModal: _unref(openBorrowAmountFromConfirm),
                    onOpenLoanOptionsModal: _unref(openLoanOptionsFromConfirm),
                    onOpenLoanConfigurationModal: _unref(openLoanConfigurationFromConfirm)
                  }, null, 8, ["onOpenSchoolConfirmationModal", "onOpenBorrowAmountModal", "onOpenLoanOptionsModal", "onOpenLoanConfigurationModal"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_4, [
                (
                _unref(showRequestFundsButton) &&
                !_unref(gettingData) &&
                !_unref(loanSvcError) &&
                _unref(loan)?.availableToBorrow > 0
              )
                  ? (_openBlock(), _createBlock(NextButton, {
                      key: 0,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (showFundsRequestModal.value = true)),
                      text: _unref(fundsRequestBtnText),
                      disabled: !_unref(loan)?.canRequestFund
                    }, null, 8, ["text", "disabled"]))
                  : _createCommentVNode("", true),
                (_unref(showPendingDisbursementNotice)(_unref(loan)))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, " You have a disbursement pending. Once your disbursement is loaded to your loan servicer, we will recalculate your amount available to request. "))
                  : _createCommentVNode("", true),
                (_unref(showFundsRequestModal))
                  ? (_openBlock(), _createBlock(RequestFundsModalOpal, {
                      key: 2,
                      loan: _unref(loan),
                      onClose: _cache[1] || (_cache[1] = ($event: any) => (showFundsRequestModal.value = false)),
                      onGetLoanDetails: _unref(getLoanDetails)
                    }, null, 8, ["loan", "onGetLoanDetails"]))
                  : _createCommentVNode("", true)
              ]),
              (_unref(showBorrowAmountModal))
                ? (_openBlock(), _createBlock(BorrowAmount, {
                    key: 2,
                    id: "borrowAmount",
                    application: __props.application,
                    term: __props.application?.schoolConfiguration?.academicTerm || '',
                    initialDrawRequest: loanConfigurationModule.value?.applicationInfo?.initialDraw,
                    loading: _unref(gettingData) || _unref(updatingApp),
                    onComplete: _unref(complete),
                    onClose: _unref(closeBorrowAmountModal)
                  }, null, 8, ["application", "term", "initialDrawRequest", "loading", "onComplete", "onClose"]))
                : _createCommentVNode("", true),
              (_unref(showSchoolConfirmationModal))
                ? (_openBlock(), _createBlock(SchoolConfirmation, {
                    key: 3,
                    id: "schoolConfirmation",
                    application: __props.application,
                    term: __props.application?.schoolConfiguration?.academicTerm || '',
                    applicant: __props.applicant,
                    loading: _unref(gettingData) || _unref(updatingApp),
                    onComplete: _unref(complete),
                    onClose: _unref(closeSchoolConfirmationModal)
                  }, null, 8, ["application", "term", "applicant", "loading", "onComplete", "onClose"]))
                : _createCommentVNode("", true),
              (_unref(showLoanOptionsModal) && !_unref(isValidProfessionalGradFlow))
                ? (_openBlock(), _createBlock(LoanOptions, {
                    key: 4,
                    id: "loanOptions",
                    application: __props.application,
                    applicant: __props.applicant,
                    initialDrawAmount: _unref(initialDrawRequest)?.amount,
                    loading: _unref(gettingData) || _unref(updatingApp),
                    onComplete: _unref(complete),
                    onClose: _unref(closeLoanOptionsModal)
                  }, null, 8, ["application", "applicant", "initialDrawAmount", "loading", "onComplete", "onClose"]))
                : _createCommentVNode("", true),
              (_unref(showLoanOptionsModal) && _unref(isValidProfessionalGradFlow) && _unref(hasRepaymentBasedRates))
                ? (_openBlock(), _createBlock(PgLoanOptionsModal, {
                    key: 5,
                    onClose: _unref(closeLoanOptionsModal),
                    onConfigurationComplete: _cache[2] || (_cache[2] = ($event: any) => (_unref(complete)($event)))
                  }, null, 8, ["onClose"]))
                : _createCommentVNode("", true),
              (_unref(showLoanOptionsModal) && _unref(isValidProfessionalGradFlow) && !_unref(hasRepaymentBasedRates))
                ? (_openBlock(), _createBlock(PelLoanOptionsModal, {
                    key: 6,
                    onClose: _unref(closeLoanOptionsModal),
                    onComplete: _unref(complete)
                  }, null, 8, ["onClose", "onComplete"]))
                : _createCommentVNode("", true),
              (_unref(error) === true)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(TimeoutModal)
                  ]))
                : _createCommentVNode("", true),
              _createVNode(OpalModal)
            ])
          ])
        ])
      ]),
      _: 1
    }),
    (_unref(isParentLOC) && !_unref(gettingData))
      ? (_openBlock(), _createBlock(StudentInformation, {
          key: 0,
          loading: _unref(gettingData),
          disabled: false,
          student: _unref(student)
        }, null, 8, ["loading", "student"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})